<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">
            <span class="note"><i style="color: red">*</i> 确定要恢复当前手术吗？</span>
            <div>
                <el-input style="margin-top: 30px" type="textarea" :rows="2" placeholder="请输入手术恢复原因" v-model="textarea" @blur="check"></el-input>
            </div>
        </div>
        <CloseButton type="confirm" @confirm="surgeryRecovery" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `surgeryRecovery`,
    props: {

    },
    data() {
        return {
            title: `手术恢复`,
            token: this.$route.query.token,
            data: {},
            msg: `closeWindow`,
            textarea: ``
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
    },
    computed: {
    },
    methods: {
        surgeryRecovery() {
            let that = this
            if (!that.check()) return false
            return new Promise((resolve) => {
                let req = that.myaxios.put(`/api/Intraoperative/Anaesthesia/RecoveryOperation/${this.$route.query.surgery_id}?reason=${this.textarea}`)
                req.then(data => {
                    that.data = { surgeryId: this.$route.query.surgery_id }
                    that.msg = `ok`
                    that.sendMessage()
                }).catch(e => { console.log(e) })
            })
        },
        check() {
            if (this.textarea === ``) {
                this.$message.warning(`恢复手术原因不能为空`)
                return false
            }
            return true
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/SurgeryRecovery.vue